import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Form as FormFinal, Field } from 'react-final-form';
import { Button, Form, Col, Spinner, Alert, Card } from 'react-bootstrap';
import { Animated } from "react-animated-css";
import { SearchAlt } from '@styled-icons/boxicons-regular/SearchAlt';

//Actions
import { pesquisa, novoatualiza } from '../../../../actions/traducoes/traducoes';
import { novoatualiza as novoatualizaevento, pesquisa as pesquisaevento} from '../../../../actions/eventos/eventos';

//Components
import { campotexto, camporadio } from '../../../../components/forms/campos/campos';

//Utils
import { getEvento } from '../../../../utils/eventosession';

const FormTraducoesPesquisa = (props) => {
    
    const [idiomas_evento, setIdiomas] = useState([]);
    const [mostramsg, setMostramsg] = useState(false);
    const listaidiomas = ['pt','en','es'];
    const evento = getEvento();
    
    const loadEvento = async () => {
        if(evento.idevento){
            const result = await props.pesquisaevento({
                idpromotora: evento.idpromotora, 
                idevento: parseInt(evento.idevento)
            });        
            setIdiomas(result[0]&&result[0].idiomavalido!==null?result[0].idiomavalido.split("|"):[]);
        }
    }

    const handleSubmit = async (form) => {            
        await props.pesquisa({
            ...form,
            idpromotora: evento.idpromotora, 
            idevento: evento.idevento,
            wherein: JSON.stringify({ 
                campo: 'identificador', 
                valores: ['passo1','end','novopasso1','conf_index']                
            })
        });
    }
    
    const handleSubmitLinguagem = async (form) => {
        let dados = '';        
        Object.keys(form).forEach(item => {
            if(form[item]){
                dados += dados===''?item:`|${item}`;
            }
        });

        await props.novoatualizaevento({
            idpromotora: evento.idpromotora, 
            idevento: parseInt(evento.idevento),
            idiomavalido: dados
        });
        setMostramsg(true);
        setTimeout(() => {
            setMostramsg(false);
            loadEvento();
        },2000);
    }

    useEffect(() => {
        loadEvento();        
    },[]);
        
    return (
        <>
        <FormFinal        
        onSubmit={handleSubmitLinguagem}
        validate={(form) => {
            const errors = {};
            if(!form.pt&&!form.en&&!form.es){
                errors.pt = 'Assinale pelo menos 1';                
            }
            return errors;
        }}
        initialValues={() => {
            let result = {};            
            idiomas_evento.forEach(itens => {                
                result = {
                    [itens]: true,
                    ...result
                }
            });            
            return result;
        }}
        render={({ form, handleSubmit }) => {
            return (
                <Card>
                    <Card.Header>Opções de Traduções</Card.Header>
                    <Card.Body>
                    <form onSubmit={handleSubmit} name="formlinguagem">                        
                        <Form.Row className="align-items-center mb-1">
                            <Col xs="auto">
                                {listaidiomas.map(itens => {
                                    return (                                    
                                        <Field
                                        key={itens}
                                        type="checkbox" 
                                        label={`Habilitar Idioma ${itens.toUpperCase()}`}
                                        name={itens}
                                        component={camporadio}
                                        placeholder={props.placeholder} />
                                    );
                                })}                            
                            </Col>
                        </Form.Row>
                        <Button type="submit">Confirmar</Button>
                        {mostramsg?
                        <Animated animationIn="fadeIn" animationOut="fadeOut" isVisible={true} animationInDuration={1000}>                
                            <Alert variant="success">Atualizando...</Alert>
                        </Animated>
                        :null}
                    </form>
                    </Card.Body>
                </Card>
            );
        }}
        />
        <FormFinal
        onSubmit={handleSubmit}            
        validate={values => {
            const errors = {};
            if(!values.portugues){
                errors.portugues = 'Obrigatório'
            }                
            return errors;
        }}
        render={({ submitting, pristine, form, handleSubmit }) => {
            
            return (
                <Card className="mt-3">
                    <Card.Header>Traduções de Textos</Card.Header>
                    <Card.Body>
                        <form onSubmit={handleSubmit} name="formtrads">
                            <Form.Row className="align-items-center mb-1">
                                <Col xs="auto">
                                    <Field type="text" 
                                    label="Pesquisa de Textos em Português" 
                                    name="portugues" 
                                    component={campotexto} 
                                    placeholder={props.placeholder} />
                                </Col>
                                <Col xs="auto">
                                    <Button type="submit" variant="primary" className="mt-4">
                                        {props.pendingTasks?
                                        <Spinner animation="border"  />
                                        :
                                        <SearchAlt size="30" disabled={pristine || submitting} />
                                        }
                                    </Button>
                                </Col>
                            </Form.Row>
                        </form>
                    </Card.Body>
                </Card>
            )
        }}
        />
        </>
    );    
}

const mapStateToProps = (state) => {
    return {        
        pendingTasks: state.pendingTasks
    }
}

export default connect(mapStateToProps, { pesquisa, novoatualiza, novoatualizaevento, pesquisaevento })(FormTraducoesPesquisa);